<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        <br />
        <br />
        {{ creditor.creditor_name }}
        <br />
        <template v-if="creditor.address">
            {{ creditor.address }}
        </template>
        <template v-else>
            {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
        </template>
        <br />
        <br />
        Date: {{ date }}
    </p>
    <p class="letter-content">
        This is a notice of dispute pursuant to the Fair Credit Reporting Act, section 623, subsection (8)(D). The specific information being disputed is the derogatory nature of the information you have furnished to the credit reporting agencies in connection with the above mentioned account.
        <br />
        <br />
        The basis for my dispute is your company was required to notify me prior to, or no later than 30 days after furnishing the negative information to the consumer reporting agencies, in writing… that such furnishing of information was going to take place. This notification is required under the FCRA, section 623, subsection (7)(A). However, I am unable to locate documentation you complied with this requirement.
        <br />
        <br />
        Therefore, provide me proof of notification (i.e. a copy of the actual notification sent), and proof that it was delivered to me in a timely manner (i.e. a dated certified mail delivery confirmation with my signature).
        <br />
        <br />
        <strong>
            If you cannot provide proof of notification and date of receipt, then you cannot substantiate you followed the procedures required under the Fair Credit Reporting Act.
        </strong>
        In addition, by not being able to substantiate you performed your duties imposed under that title, you are now in direct violation of it.
        <br />
        <br />
        Therefore, the continued reporting of negative information to the credit reporting agencies in connection with the above mentioned account may constitute the furnishing of false information with malice or willful intent to injure me.
        <br />
        <br />
        To correct this error I suggest you modify the account accordingly, report the results of your investigation to the consumer reporting agencies to which you furnished the information, and provide me written verification thereof.
        <br />
        <br />
        <strong>
            You have 30 days from the date you receive this notice to complete your investigation and respond pursuant to the Fair Credit Reporting Act, section 623(8)(E)(iii).
        </strong>
        <br />
        In the event you fail to respond to this dispute or provide insufficient proof of notification and date of receipt, I will have no other choice but to seek administrative enforcement with all applicable agencies identified in section 621. In addition, I may also seek the assistance of a legal firm specializing in class action lawsuits.
        <br />
        <br />
        This request is being sent CERTIFIED MAIL to insure it is processed in a timely manner. Thank you in advance for your cooperation.
        <br />
        <br />
        Sincerely,
        <br />
        <br />
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        <br />
    </p>

</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>
